module.exports = __webpack_public_path__ + "media/images/common-nav/national-forests/ozark_national_forest-9b03491c925cd1d9e2397983a55822fd.jpg";